/** @format */
/* eslint-disable */
import dayjs from 'dayjs';
import { $csI18n } from '@/js/modules/csI18n';

const $_yearPrivate = {
    /**
     * @public
     * @description
     * Will return the year to start the range with, provided its allowed within our offset
     * 
     * @param {Integer} startYear 
     * @param {Integer} minYear - the earliest allowed year via our settings
     * @param {Integer} offsetAmount - how many years are we offsetting by
     * 
     * @returns {String} 
     */
    getRangeStart(startYear, minYear, offsetAmount = 10) {
		let target = startYear - offsetAmount; // 2010
		if (minYear != undefined) {
			if (minYear > target) {
				target = minYear;
			}
			if (minYear > startYear) {
				// may need revisiting in due course
				throw new Error($csI18n.t('datepicker.minYearTooHigh', [minYear, startYear]));
			}
		}
		return target;
	},

    /**
     * @public
     * @description
     * Will return the year to end the range with, provided its allowed within our offset
     * 
     * @param {Integer} startYear 
     * @param {Integer} maxYear - the latest allowed year via our settings
     * @param {Integer} offsetAmount - how many years are we offsetting by
     * 
     * @returns {String} 
     */
	getRangeEnd(startYear, maxYear, offsetAmount = 10) {
		let target = startYear + offsetAmount; // 2010
		if (maxYear != undefined) {
			if (maxYear < target) {
				target = maxYear;
			}
			if (maxYear < startYear) {
				target = maxYear;
			}
		}
		return target;
	}
}

export const $_year = {
    /**
     * @public
     * @description
     * Gets a range of years governed by what we've configured to be our
     * available start and end years.
     * 
     * @param {Integer} startYear 
     * @param {Object} instance - the active datepicker instance.
     * 
     * @returns {Array} 
     */
	range(startYear, {minYear, maxYear, yearRange = 10}) {
		if (!startYear) {
			const date = dayjs();
			startYear = parseInt(date.format('YYYY'));
		}
		const startYearOffset = $_yearPrivate.getRangeStart(startYear, minYear, yearRange);
		const endYearOffset = $_yearPrivate.getRangeEnd(startYear, maxYear, yearRange);
		const years = [];

		for (let i = startYearOffset; i <= endYearOffset; i++) {
			years.push(i);
		}

		return years;
	},

	
};

export {$_year as default};
